import utils from '@utils';
import resources from '@resources';

export const email = (
  errors: {[key: string]: any},
  values: {[key: string]: any},
  options: {
    key: string;
    require: boolean;
  } = {
    key: 'email',
    require: true,
  }
) => {
  if (!values[options.key] && options.require) {
    errors[options.key] = 'メールアドレスは必須入力です';
  } else if (values[options.key]) {
    if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i.test(values[options.key])
    ) {
      errors[options.key] = 'メールアドレスを正しく入力してください';
    } else if (!/^[0-9+a-zA-Z-@._]+$/i.test(values[options.key])) {
      errors[options.key] = 'メールアドレスを正しく入力してください';
    }
  }
};

export const phoneNumber = (
  errors: {[key: string]: any},
  values: {[key: string]: any},
  options: {
    key: string;
  } = {key: 'phoneNumber'}
) => {
  if (values[options.key].length && values[options.key].length !== 13) {
    errors[options.key] = '携帯番号はハイフンも入力した13桁で入力してください';
  }
  if (
    !/^\d{3}-\d{4}-\d{4}$/.test(values[options.key]) &&
    values[options.key].length
  ) {
    errors[options.key] =
      '携帯番号は半角数字のxxx-xxxx-xxxx形式で入力してください';
  }
};
export const kana = (
  errors: {[key: string]: any},
  values: {[key: string]: any},
  options: {
    key: string;
    require: boolean;
    label: string;
  }
) => {
  if (!values[options.key] && options.require) {
    errors[options.key] = `${options.label}は必須入力です`;
    return;
  }

  if (!/^[ｦ-ﾟ ァ-ヶー]+$/.test(values[options.key])) {
    errors[options.key] = 'カタカナで入力してください';
  }
};

export const password = (
  errors: {[key: string]: any},
  values: {[key: string]: any},
  options: {
    key: string;
    require: boolean;
    label: string;
  }
) => {
  if (!values[options.key]) {
    errors[options.key] = `${options.label}は必須入力です`;
    return;
  }

  if (
    !/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]+$/.test(values[options.key])
  ) {
    errors[options.key] = 'パスワードには大文字・小文字・数字の入力が必要です';
  }
  if (values[options.key].length < 8) {
    errors[options.key] = 'パスワードは8文字以上で入力してください';
  }
};

export const birthdate = (
  errors: {[key: string]: any},
  values: {[key: string]: any},
  keys: {
    year: string;
    month: string;
    day: string;
  }
) => {
  const errorMessage = '正しい生年月日を入力してください';

  const year = values[keys.year];
  const month = values[keys.month];
  const day = values[keys.day];

  // 値が全て存在しない場合、チェックしない
  if (!year && !month && !day) {
    return;
  }

  if (!year) {
    errors[keys.year] = errorMessage;
  }

  if (!month) {
    errors[keys.month] = errorMessage;
  }

  if (!day) {
    errors[keys.day] = errorMessage;
  }

  const date = resources.users.getBirthDate(year, month, day);
  // 全ての値が存在する場合のエラー
  if (year && month && day) {
    // 無効な日付だった場合エラー
    if (!utils.date.isValid(date)) {
      errors[keys.day] = errorMessage;
    }

    // その年月に存在する日よりも大きい場合のエラー
    if (utils.date.getDaysInMonth({year, month}) < day) {
      errors[keys.day] = errorMessage;
    }
  }
};

export const vaildDate = (
  values: {[key: string]: any},
  errors: {[key: string]: any},
  fieldName: string
) => {
  const isVaild = utils.date.validateFormat(values[fieldName], 'YYYY/MM/DD');

  if (!isVaild) {
    errors[fieldName] = '正しい日付を入力してください';
  }
};
